import React from 'react';
import { Trophy, Gift, Award, Star, ArrowRight, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';

const prizes = [
  {
    icon: Trophy,
    title: "Primer Premio",
    prize: "Lote de Navidad Premium",
    description: "Un exclusivo lote con los mejores productos navideños valorado en más de 200€",
    features: [
      "Bebidas premium",
      "Productos gourmet",
      "Turrones artesanos",
      "Embutidos ibéricos"
    ],
    color: "from-yellow-500 to-amber-600",
    shadowColor: "shadow-yellow-500/20"
  },
  {
    icon: Gift,
    title: "Segundo Premio",
    prize: "Tarjeta Regalo El Corte Inglés",
    description: "Para que elijas lo que más te guste de cualquier departamento",
    features: [
      "Valor de 75€",
      "Válida 1 año",
      "Todas las tiendas",
      "Cualquier producto"
    ],
    color: "from-blue-500 to-blue-600",
    shadowColor: "shadow-blue-500/20"
  },
  {
    icon: Award,
    title: "Tercer Premio",
    prize: "Tarjeta Regalo TodoJuguete",
    description: "Disfruta comprando en la mejor tienda de juguetes online",
    features: [
      "Valor de 40€",
      "Compras online",
      "Miles de juguetes",
      "Envío gratis"
    ],
    color: "from-green-500 to-green-600",
    shadowColor: "shadow-green-500/20"
  }
];

export default function PrizesShowcase() {
  return (
    <div className="py-12 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 bg-gradient-to-b from-primary via-primary to-primary-dark">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0zNiAxOGMzLjMxIDAgNiAyLjY5IDYgNnMtMi42OSA2LTYgNi02LTIuNjktNi02IDIuNjktNiA2LTZ6bTEyIDI0YzMuMzEgMCA2IDIuNjkgNiA2cy0yLjY5IDYtNiA2LTYtMi42OS02LTYgMi42OS02IDYtNnptLTI0IDAtNiA2djZoNnY2aDZ2LTZoNnYtNmgtNnYtNmgtNnY2aC02eiIgc3Ryb2tlPSIjZmZmIiBzdHJva2Utb3BhY2l0eT0iLjEiIHN0cm9rZS13aWR0aD0iMiIvPjwvZz48L3N2Zz4=')] opacity-5"></div>
      </div>

      <div className="container mx-auto px-4">
        {/* Title Section */}
        <div className="text-center mb-8 relative">
          <div className="inline-block">
            <div className="relative">
              <h2 className="text-4xl md:text-5xl font-bold text-white mb-2 relative z-10">
                ¿Qué Puedes Ganar?
              </h2>
              <div className="absolute -top-6 -right-6 transform rotate-12">
                <div className="relative">
                  <Sparkles className="h-12 w-12 text-secondary animate-pulse" />
                  <div className="absolute inset-0 blur-sm">
                    <Sparkles className="h-12 w-12 text-secondary opacity-50" />
                  </div>
                </div>
              </div>
            </div>
            <div className="h-1 w-24 bg-gradient-to-r from-secondary to-secondary/50 rounded-full mx-auto mt-4"></div>
          </div>
        </div>

        <div className="text-center mb-6">
          <p className="text-lg text-gray-200 max-w-2xl mx-auto">
            Los mejores árboles serán recompensados con estos fantásticos premios
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {prizes.map((prize, index) => {
            const Icon = prize.icon;
            return (
              <div
                key={index}
                className="relative group h-full flex"
              >
                <div className={`absolute -inset-0.5 bg-gradient-to-r ${prize.color} rounded-2xl blur opacity-30 group-hover:opacity-100 transition duration-1000 group-hover:duration-200 animate-tilt`}></div>
                <div className="relative bg-white/10 backdrop-blur-sm rounded-xl p-6 ring-1 ring-white/10 hover:ring-white/20 transition-all duration-300 flex flex-col flex-1">
                  <div className="absolute -top-4 left-1/2 -translate-x-1/2">
                    <div className={`w-10 h-10 rounded-lg bg-gradient-to-br ${prize.color} flex items-center justify-center ${prize.shadowColor} shadow-lg transform -rotate-3 group-hover:rotate-3 transition-transform duration-300`}>
                      <Icon className="h-5 w-5 text-white" />
                    </div>
                  </div>

                  <div className="pt-6 flex flex-col flex-1">
                    <h3 className="text-base font-semibold text-white text-center mb-1">{prize.title}</h3>
                    <p className="text-lg font-bold text-center mb-3 bg-gradient-to-r from-white to-gray-300 bg-clip-text text-transparent">
                      {prize.prize}
                    </p>
                    <p className="text-sm text-gray-300 text-center mb-4">{prize.description}</p>
                    
                    <ul className="space-y-2 mt-auto">
                      {prize.features.map((feature, i) => (
                        <li key={i} className="flex items-center text-sm text-gray-300">
                          <Star className="h-3 w-3 text-secondary mr-2 flex-shrink-0" />
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/premios"
            className="inline-flex items-center bg-white/10 hover:bg-white/20 text-white px-6 py-2 rounded-full transition-colors group text-sm"
          >
            Ver todos los detalles
            <ArrowRight className="h-4 w-4 ml-2 transform group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
      </div>
    </div>
  );
}